module.exports = __webpack_public_path__ + "img/empoli.69b37319.png";